import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import EmployeeList from '../employeeList/AllEmpoyee';
// Reuse the employee detail component from Employees
import EmployeeDetails from '../../Employees/employeeDetail/index';
import { EmployeeProvider } from '../context/directoryContext';

function EmployeeRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"EMPLOYEEE HEREEEEEEEEEEEEE")

  return (
    <EmployeeProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>
        <Route index element={<EmployeeList />} /> {/* Matches `/company-directory` */}
        <Route path=":id" element={<EmployeeDetails />} /> {/* Matches `/company-directory/:id` */}
      </Route>
    </Routes>
    </EmployeeProvider>
  );
}

export default EmployeeRouter;
